import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// ENTITIES
import { RequestPesquisarRg } from 'pages/iirgd/RgFicDigital/PesquisaRg/Formulario/form';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types } from './types';

// ACTIONS
import {
	consultaPesquisaCidadaoKitFamiliaSuccess,
	consultaPesquisaCidadaoKitFamiliaFailure,
} from './actions';

function* consultaPesquisaCidadaoKitFamiliaRequest(
	request: ReducerActionRotaSP,
) {
	const { token, payload }: { token?: string; payload: any } = request;
	const { data }: { data: RequestPesquisarRg } = payload;
	const { usuario, ...params } = data;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		'cidadao',
		params,
		undefined,
		undefined,
		undefined,
		usuario,
		undefined,
	);

	if (response.status === 200) {
		yield put(consultaPesquisaCidadaoKitFamiliaSuccess(response));
	} else {
		yield put(consultaPesquisaCidadaoKitFamiliaFailure(response));
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_PESQUISA_CIDADAO_KIT_FAMILIA_REQUEST,
		consultaPesquisaCidadaoKitFamiliaRequest,
	),
]);
